import { global } from './lib/utils/globals';
global.probe = {};
//# sourceMappingURL=init.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/probe.gl/dist/esm/init.js
// module id = 583
// module chunks = 0